import { createContext } from 'react';

export type IncidentReportDetailModalContextProps = {
  incidentReportId: string | null;
  isOpen: boolean;
  openModal: (id: string) => void;
  closeModal: () => void;
};

export const IncidentReportDetailModalContext = createContext<IncidentReportDetailModalContextProps>({
  incidentReportId: null,
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
});